import { render } from "./activities.vue?vue&type=template&id=3130688a&ts=true"
import script from "./activities.vue?vue&type=script&lang=ts"
export * from "./activities.vue?vue&type=script&lang=ts"

import "./activities.vue?vue&type=style&index=0&id=3130688a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__